import axios from "@/config/axios";
import mime from "mime";


const state = {
  currentProcesses: {
    data: "Cargando procesos...",
  },
  user: {
    diasAConsultar: 0,
    filtroLlaveProceso: "",
    soloConActuacionesRecientes: false,
    conNotificacionPorEmail: false,
    loading: false,
  },
  actions: {
    usuarioActuaciones: [],
    paginacion: {
      cantidadRegistros: 0,
      registrosPagina: 0,
      cantidadPaginas: 0,
      pagina: 0,
    },
    loading: true,
  },
  errors: {
    template: "",
  },
  isLoading: {
    update: false,
    add: false,
    delete: false,
  },
  feedbackModal: {
    show: false,
    message: "",
  },
};

const mutations = {
  SET_PROCESSES(state, payload) {
    state.currentProcesses = payload;
  },
  SET_USER(state, payload) {
    state.user = payload;
  },
  LOADING_UPDATE(state, payload) {
    state.isLoading.update = payload;
  },
  LOADING_ADD(state, payload) {
    state.isLoading.add = payload;
  },
  LOADING_DELETE(state, payload) {
    state.isLoading.delete = payload;
  },
  SET_ACTIONS(state, payload) {
    state.actions = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },

  // Deprecating
  SET_MODAL(state, payload) {
    state.feedbackModal = payload;
  },
};

const getters = {
  getProcesses(state) {
    return state.currentProcesses;
  },
  getUserData(state) {
    return state.user;
  },
  getActions(state) {
    return state.actions;
  },
  getErrors(state) {
    return state.errors;
  },
  isLoading(state) {
    return state.isLoading;
  },
  getModal(state) {
    return state.feedbackModal;
  },
};

const actions = {
  async getProcesses({ commit, rootState, dispatch }, { email }) {
    try {
      const request = await axios
        .get(
          `/Seguimiento/Procesos/${email}`,
          {
            headers: {
              Authorization: `bearer ${rootState.auth.authUser.jwt}`,
            },
          }
        )
        .catch((e) => {
          let message = "";
          if (e.response && e.response.status == 401) {
            message = "Tu sesión expiro, por favor ingresa de nuevo.";
            commit("auth/CLEAR_AUTH_USER", null, { root: true });
          } else if (e.response && e.response.data.Message) {
            message = e.response.data.Message;
          } else {
            message = "Hubo un error, refresca e intenta de nuevo";
          }
          dispatch(
            "process/showNotifier",
            {
              message: message,
              type: "error",
            },
            { root: true }
          );
        });

      const processes = await request.data
        .map((process) => `${process.llaveProceso}`)
        .toString()
        .replace(/,/g, "\r\n");

      const response = {
        success: true,
        data: processes || "No se encontraron procesos en seguimiento",
      };

      commit("SET_PROCESSES", response);
    } catch (error) {
      const response = {
        success: false,
        data: [],
      };
      commit("SET_PROCESSES", response);
    }
  },
  async updateUserSettings({ commit, dispatch, rootState }, { form, email }) {
    commit("LOADING_UPDATE", true);
    form.usuario = email;
    
    try {
      const request = await axios
        .put(
          `/Seguimiento/Usuario`,
          form,
          {
            headers: {
              Authorization: `bearer ${rootState.auth.authUser.jwt}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            dispatch("getProcesses", { email });
            dispatch("getUserActions", { email });
            // // commit("LOADING_UPDATE", false);
          }
        })
        .catch((e) => {
          let message = "";
          if (e.response && e.response.status == 401) {
            message = "Tu sesión expiro, por favor ingresa de nuevo.";
            commit("auth/CLEAR_AUTH_USER", null, { root: true });
          } else if (e.response && e.response.data.Message) {
            message = e.response.data.Message;
          } else {
            message = "Hubo un error, refresca e intenta de nuevo";
          }
          dispatch(
            "process/showNotifier",
            {
              message: message,
              type: "error",
            },
            { root: true }
          );
        })
        .finally(commit("LOADING_UPDATE", false));
    } catch (error) {
      console.log(error);
      commit("LOADING_UPDATE", false);
    }
  },
  async addProcesses({ commit, dispatch, rootState }, payload) {
    commit("LOADING_ADD", true);
    const processes = payload;
    processes.ProcesosAEditar = processes.ProcesosAEditar.replace(
      /[\n]/g,
      "\r\n"
    );
    try {
      const request = await axios
        .post(
          `/Seguimiento/Procesos`,
          processes,
          {
            headers: {
              Authorization: `bearer ${rootState.auth.authUser.jwt}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            const { data } = res;
            console.log("Add success");
            commit("LOADING_ADD", false);

            // commit("LOADING_UPDATE", true);
            // dispatch("getProcesses",  payload.usuario );
            // console.log(payload.usuario)
            // dispatch("getUserActions", payload.usuario );
            // commit("LOADING_UPDATE", false);

            dispatch(
              "process/showNotifier",
              {
                message: `Fueron agregados ${data.procesados} procesos de ${data.totales} enviados.`,
                type: "success",
              },
              { root: true }
            );
          }
        })
        .catch((e) => {
          let message = "";
          if (e.response && e.response.status == 401) {
            message = "Tu sesión expiro, por favor ingresa de nuevo.";
            commit("auth/CLEAR_AUTH_USER", null, { root: true });
          } else if (e.response && e.response.data.Message) {
            message = e.response.data.Message;
          } else {
            message = "Hubo un error, refresca e intenta de nuevo";
          }
          dispatch(
            "process/showNotifier",
            {
              message: message,
              type: "error",
            },
            { root: true }
          );
        })
        .finally(commit("LOADING_ADD", false));
    } catch (error) {
      console.log(error);
      commit("LOADING_ADD", false);

      dispatch(
        "process/showNotifier",
        {
          message: error,
          type: "error",
        },
        { root: true }
      );
    }
  },
  async deleteProcesses({ commit, dispatch, rootState }, payload) {
    commit("LOADING_DELETE", true);
    const processes = payload;
    processes.ProcesosAEditar = processes.ProcesosAEditar.replace(
      /[\n]/g,
      "\r\n"
    );

    try {
      const request = await axios
        .delete(
          `/Seguimiento/Procesos`,
          {
            data: processes,
            headers: {
              Authorization: `bearer ${rootState.auth.authUser.jwt}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            const { data } = res;
            console.log("Delete success");

            // // dispatch("getProcesses",  payload.usuario );
            // // dispatch("getUserActions", payload.usuario );

            dispatch(
              "process/showNotifier",
              {
                message: `Fueron eliminados ${data.procesados} procesos de ${data.totales} enviados.`,
                type: "success",
              },
              { root: true }
            );
          }
        })
        .catch((e) => {
          console.log(e);
          let message = "";
          if (e.response && e.response.status == 401) {
            message = "Tu sesión expiro, por favor ingresa de nuevo.";
            commit("auth/CLEAR_AUTH_USER", null, { root: true });
          } else if (e.response && e.response.data.Message) {
            message = e.response.data.Message;
          } else {
            message = "Hubo un error, refresca e intenta de nuevo";
          }
          dispatch(
            "process/showNotifier",
            {
              message: message,
              type: "error",
            },
            { root: true }
          );
        })
        .finally(commit("LOADING_DELETE", false));
    } catch (error) {
      console.log(error);
      commit("LOADING_DELETE", false);
      dispatch(
        "process/showNotifier",
        {
          message: error,
          type: "error",
        },
        { root: true }
      );
    }
  },
  async uploadFile({ commit, dispatch, rootState }, payload) {
    let formData = new FormData();
    formData.append("file", payload.file);

    try {
      await axios
        .post(
          `/Seguimiento/SubirPlantilla/${payload.email}`,
          formData,
          {
            headers: {
              Authorization: `bearer ${rootState.auth.authUser.jwt}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            const { data } = res;

            dispatch(
              "process/showNotifier",
              {
                message: `Fueron agregados ${data.procesados} procesos de ${data.totales} enviados.`,
                type: "success",
              },
              { root: true }
            );
          }
        })
        .catch((e) => {
          let message = "";
          if (e.response && e.response.status == 401) {
            message = "Tu sesión expiro, por favor ingresa de nuevo.";
            commit("auth/CLEAR_AUTH_USER", null, { root: true });
          } else if (e.response && e.response.data.Message) {
            message = e.response.data.Message;
          } else {
            message = "Hubo un error, refresca e intenta de nuevo";
          }
          dispatch(
            "process/showNotifier",
            {
              message: message,
              type: "error",
            },
            { root: true }
          );
        });
    } catch (error) {
      console.log(error);
      commit("LOADING_ADD", false);

      dispatch(
        "process/showNotifier",
        {
          message: error,
          type: "error",
        },
        { root: true }
      );
    }
  },
  async downloadTemplate({ commit, dispatch, rootState }) {
    const request = axios({
      url:
        `/Seguimiento/DescargarPlantilla`,
      method: "GET",
      responseType: "blob",
      headers: {
        Authorization: `bearer ${rootState.auth.authUser.jwt}`,
      },
    })
      .then((response) => {

        let ext = mime.getExtension(response.headers["content-type"]);
        let blob = new Blob([response.data]);
        let fileURL = window.URL.createObjectURL(blob);
        let fileLink = document.createElement("a");
        let nombre = `CPNU_SeguimientoProcesos_Importar.${ext}`;
        fileLink.href = fileURL;
        fileLink.setAttribute("download", nombre);
        document.body.appendChild(fileLink);

        fileLink.click();
      })
      .catch((e) => {
        console.log(e);
        let message = "";
        if (e.response && e.response.status == 401) {
          message = "Tu sesión expiro, por favor ingresa de nuevo.";
          commit("auth/CLEAR_AUTH_USER", null, { root: true });
        } else if (e.response && e.response.data.Message) {
          message = e.response.data.Message;
        } else {
          message = "Error inesperado al descargar la plantilla";
        }
        dispatch(
          "process/showNotifier",
          {
            message: message,
            type: "error",
          },
          { root: true }
        );
        commit("SET_ERRORS", {
          template: "Error inesperado al descargar la plantilla",
        });
      });
  },
  async downloadExcel({ commit, dispatch, rootState }, {email}) {
    const request = axios({
      url:
        `/Seguimiento/DescargarExcel/${email}`,
      method: "GET",
      responseType: "blob",
      headers: {
        Authorization: `bearer ${rootState.auth.authUser.jwt}`,
      },
    })
      .then((response) => {   
        
        let nombre =
          response.headers['content-disposition'].split('filename=')[1].split(';')[0];

        // Si no se logra extraer el nombre de archivo desde la cabecera
        if (nombre === undefined){
          let ext = mime.getExtension(response.headers['content-type']);
          nombre = `CPNU_SeguimientoProcesos_Actuaciones.${ext}`;
        }        
        
        debugger
        let blob = new Blob([response.data]);
        let fileURL = window.URL.createObjectURL(blob);
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", nombre);
        document.body.appendChild(fileLink);

        fileLink.click();
      })
      .catch((e) => {
        console.log(e);
        let message = "";
        if (e.response && e.response.status == 401) {
          message = "Tu sesión expiro, por favor ingresa de nuevo.";
          commit("auth/CLEAR_AUTH_USER", null, { root: true });
        } else if (e.response && e.response.data.Message) {
          message = e.response.data.Message;
        } else {
          message = "Error inesperado al descargar el Excel";
        }
        dispatch(
          "process/showNotifier",
          {
            message: message,
            type: "error",
          },
          { root: true }
        );
        commit("SET_ERRORS", {
          template: "Error inesperado al descargar la plantilla",
        });
      });
  },
  async getUserData({ commit, rootState, dispatch }, { email }) {
    try {
      const request = await axios
        .get(
          `/Seguimiento/Usuario/${email}`,
          {
            headers: {
              Authorization: `bearer ${rootState.auth.authUser.jwt}`,
            },
          }
        )
        .catch((e) => {
          let message = "";
          if (e.response && e.response.status == 401) {
            message = "Tu sesión expiro, por favor ingresa de nuevo.";
            commit("auth/CLEAR_AUTH_USER", null, { root: true });
          } else if (e.response && e.response.data.Message) {
            message = e.response.data.Message;
          } else {
            message = "Hubo un error, refresca e intenta de nuevo";
          }
          dispatch(
            "process/showNotifier",
            {
              message: message,
              type: "error",
            },
            { root: true }
          );
        });

      commit("SET_USER", request.data);
    } catch (error) {
      console.log(error);
    }
  },
  async getUserActions({ commit, rootState }, { email }) {
    try {
      const request = await axios
        .get(
          `/Seguimiento/Actuaciones/${email}`,
          {
            headers: {
              Authorization: `bearer ${rootState.auth.authUser.jwt}`,
            },
          }
        )
        .catch((e) => {
          let message = "";
          if (e.response && e.response.status == 401) {
            message = "Tu sesión expiro, por favor ingresa de nuevo.";
            commit("auth/CLEAR_AUTH_USER", null, { root: true });
          } else if (e.response && e.response.data.Message) {
            message = e.response.data.Message;
          } else {
            message = "Hubo un error, refresca e intenta de nuevo";
          }
          dispatch(
            "process/showNotifier",
            {
              message: message,
              type: "error",
            },
            { root: true }
          );
        });

      commit("SET_ACTIONS", request.data);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
